// extracted by mini-css-extract-plugin
export default {"note":"styles_note__Kg4Uo","light":"styles_light__Q9vPR"};